export default class AddCategoryMappingRequest {
    public reportDefinitionId: string = "";
    
    public productGroupId: string | null = null;

    public productTypes: string[] = []

}